export const EFFECT_BLOT_NAME = 'effect'
export const EFFECT_TAG_NAME = 'effect'
export const EFFECT_MODULE_NAME = 'effectModule'
